




















































































import { Vue, Component, Prop } from 'vue-property-decorator';
import ModalComponent from '@/shared/modal/modal.component.vue';
import ModalOptions from '@/shared/modal/modal-options.entity';
import AuditHomeTime from '@/domain/schedule/activitie/audit-home-time.entity';
import EmployeeScheduleService from '@/domain/schedule/employee/employee-schedule.service';
import moment from 'moment';
import { VbSnackbarService } from 'bag-of-holding-library';
import MonthYearSelect from '@/shared/month-year-picker/month-year-select.component.vue';
import LabelSlot from '@/shared/slots/label-slot.component.vue';
import DateFormat from '@/shared/utils/date-format';
import Loading from '@/shared/loading/loading.component.vue';
import TextArea from '@/shared/fields/text-area.component.vue';
import ActivityFileItemComponent from './activity-file-item.component.vue';
import AuditActionButtons from './audit-action-buttons.component.vue';

@Component({
  name: 'AuditHomeTimeModal',
  components: {
    ModalComponent,
    MonthYearSelect,
    LabelSlot,
    Loading,
    TextArea,
    ActivityFileItemComponent,
    AuditActionButtons,
  },
})
export default class AuditHomeTimeModal extends Vue {
  @Prop() openModal!: boolean;

  get optionsHandled(): ModalOptions {
    return {
      title: 'Auditar Atividades Tempo de Casa',
      titleSize: '20px',
      description: '',
      showOk: false,
      disabledOk: false,
      showCancel: true,
      labelCancel: 'fechar',
      width: 800,
    };
  }

  activities: AuditHomeTime[] = [];

  expectedDateFilterInput: string = moment().format('YYYY-MM');

  loading: boolean = false;

  get expectedDate(): string {
    return DateFormat.monthYearToFormated(this.expectedDateFilterInput);
  }

  set expectedDate(value: string) {
    this.expectedDateFilterInput = DateFormat.monthYearFromFormated(value);
  }

  created() {
    this.getActivities();
  }

  async getActivities() {
    try {
      this.loading = true;
      this.activities = await EmployeeScheduleService
        .getHomeTimeActivities(this.expectedDateFilterInput);
    } catch (error) {
      VbSnackbarService.handleHttpError(error);
    } finally {
      this.loading = false;
    }
  }

  get pendingActivitiesCount(): number {
    return this.activities.filter(activity => activity.status === 'Pendente').length;
  }

  get approvedActivitiesCount(): number {
    return this.activities.filter(activity => activity.status === 'Aprovada').length;
  }

  showActionButtons(activity: AuditHomeTime): boolean {
    return activity.files.length > 0;
  }

  getHomeTime(defaultDate: string, db1StartDate: string): string {
    return DateFormat.diffInYearsString(db1StartDate, defaultDate);
  }
}
